<template>
  <div class="table-details">
    <b-overlay :show="loading">
      <div style="min-height: 50px" class="mb-2 p-2 text-center" v-if="loading">
        Loading information...
      </div>
      <product-notes
        v-if="info"
        :product-information="info"
        :result="result"
        visible
        hide-title
        show-wishlist
      ></product-notes>

      <div v-if="showProductPageLink && !loading" class="mb-4 text-center">
        <b-button :href="result._source.Permalink">View more information...</b-button>
      </div>
    </b-overlay>

    <div class="product-prices">
      <product-format :product="result"></product-format>
      <product-format
        v-for="format in info.formats"
        :product="format"
        :key="format._id"
      ></product-format>
    </div>
  </div>
</template>

<script>
import jbs_api from "@/modules/jbs-api";

import ProductFormat from "@/components/ProductFormat";
import ProductNotes from "@/components/ProductNotes";

export default {
  components: {
    ProductFormat,
    ProductNotes,
  },
  props: {
    result: {
      type: [Boolean, Object],
      default: false,
    },
    showProductPageLink: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      loading: false,
      info: false,
    };
  },
  mounted() {
    this.loading = true;
    this.fetch_info();
  },
  methods: {
    on_show() {
      if (!this.info) {
        this.loading = true;

        this.fetch_info();
      }
    },
    fetch_info() {
      jbs_api
        .get("product-information", { params: { id: this.result._id } })
        .then((response) => {
          this.info = response.data;
          this.loading = false;
        });
    },
  },
};
</script>